/**
 * Признак того, что справочники не загрузились.
 *
 * Справочники читают шесть мест карточки, и каждое молча проглатывало отказ:
 * приложение не ломалось, а просто показывало пустые списки. Так и вышло
 * с субъектами РФ — сервер отвечал 500 на каждый запрос, а в карточке это
 * выглядело как «в списке почему-то ничего нет». Юрист в такой ситуации
 * ищет ошибку у себя и в конце концов вписывает данные руками, хотя работать
 * нельзя вовсе: без справочника судов не определить подсудность.
 *
 * Поэтому отказ отмечается в одном месте и показывается один раз — полосой
 * над карточкой, а не шестью одинаковыми сообщениями.
 *
 * Состояние намеренно живёт вне React: отмечают его обработчики загрузки
 * в разных блоках, и протаскивать через них общий контекст пришлось бы
 * через всё дерево.
 */

import { useEffect, useState } from 'react';

let failures = 0;
const listeners = new Set<() => void>();

function notify(): void {
  listeners.forEach((listener) => listener());
}

/** Отметить неудачу чтения справочника. Годится как обработчик .catch. */
export function noteDictionaryFailure(): void {
  failures += 1;
  notify();
}

/** Сброс — при повторной попытке чтения. */
export function resetDictionaryFailures(): void {
  if (failures === 0) return;
  failures = 0;
  notify();
}

export function dictionaryFailures(): number {
  return failures;
}

/** Сколько справочников не прочиталось. Ноль — всё в порядке. */
export function useDictionaryFailures(): number {
  const [value, setValue] = useState(failures);

  useEffect(() => {
    const listener = () => setValue(failures);
    listeners.add(listener);
    listener();
    return () => {
      listeners.delete(listener);
    };
  }, []);

  return value;
}
